export const defaultSectors = {
  font: {
    id: 'fonts',
    name: "字体",
    open: true,
    buildProps: ["font-family", "font-size", "font-weight", "text-align", "line-height"],
    properties: [
      {
        property: "font-family",
        list: [
          { value: "Arial, Helvetica, sans-serif", name: "Arial" },
          { value: "Arial Black, Gadget, sans-serif", name: "Arial Black" },
          { value: "Brush Script MT, sans-serif", name: "Brush Script MT" },
          { value: "Comic Sans MS, cursive, sans-serif", name: "Comic Sans MS" },
          { value: "Courier New, Courier, sans-serif", name: "Courier New" },
          { value: "Georgia, serif, sans-serif", name: "Georgia" },
          { value: "Helvetica, serif, sans-serif", name: "Helvetica" },
          { value: "Impact, Charcoal, sans-serif", name: "Impact" },
          { value: "Lucida Sans Unicode, Lucida Grande, sans-serif", name: "Lucida Sans Unicode" },
          { value: "Tahoma, Geneva, sans-serif", name: "Tahoma" },
          { value: "Times New Roman, Times, serif, sans-serif", name: "Times New Roman" },
          { value: "Trebuchet MS, Helvetica, sans-serif", name: "Trebuchet MS" },
          { value: "Verdana, Geneva, sans-serif", name: "Verdana" },
          { value: "DS-Digital", name: "DS-Digital" },
          { value: "庞门正道", name: "庞门正道" },
        ],
      },
      {
        property: "font-size",
        type: "integer",
        units: ["px", "em", "rem", "%"],
        defaults: "12",
        min: 0,
        fixedValues: [
          "medium",
          "xx-small",
          "x-small",
          "small",
          "large",
          "x-large",
          "xx-large",
          "smaller",
          "larger",
          "length",
          "initial",
          "inherit",
        ],
      },
      {
        name: "加粗",
        property: "font-weight",
        type: "select",
        defaults: "400",
        list: [
          { value: "100", name: "100px" },
          { value: "200", name: "200px" },
          { value: "300", name: "300px" },
          { value: "400", name: "400px" },
          { value: "500", name: "500px" },
          { value: "600", name: "600px" },
          { value: "700", name: "700px" },
          { value: "800", name: "800px" },
          { value: "900", name: "900px" },
        ],
      },
      {
        property: "text-align",
        list: [
          { value: "left", className: "fa fa-align-left" },
          { value: "center", className: "fa fa-align-center" },
          { value: "right", className: "fa fa-align-right" },
          { value: "justify", className: "fa fa-align-justify" },
        ],
      }
    ],
  },
  visibility: {
    id: "visibility",
    name: "位置及尺寸",
    open: false,
    buildProps: ['left', 'top', 'width', 'height', 'padding', 'display', 'position', 'z-index'],
  },
  colors: {
    id: "colors",
    name: "颜色及边框",
    open: false,
    buildProps: ["color", "background", "background-color", "border", "border-radius"],
    properties: [
      {
        property: "border",
        type: "composite",
        properties: [
          {
            property: "border-width",
            type: "integer",
            units: ["px", "em"],
            defaults: 0,
            min: 0,
          },
          {
            property: "border-style",
            type: "select",
            defaults: "solid",
            list: [
              { value: "none", name: "无边框" },
              { value: "solid", name: "实线边框" },
              { value: "dotted", name: "点线边框" },
              { value: "dashed", name: "虚线边框" },
              { value: "double", name: "双线边框" },
              { value: "groove", name: "3D凹槽边框" },
              { value: "ridge", name: "3D凸起边框" },
              { value: "inset", name: "3D凹边" },
              { value: "outset", name: "3D凸边" },
            ],
          },
          {
            property: "border-color",
            type: "color",
            defaults: "#000",
          },
        ],
      }
    ]
  },
  //   {
  //   id: "sector-pos-child-location",
  //     name: "定位方式",
  //       open: false,
  //         buildProps: [
  //           "position",
  //           "right",
  //           "bottom",
  //           "z-index",
  //           "display",
  //           "overflow",
  //           "flex-direction",
  //           "flex-wrap",
  //           "justify-content",
  //           "align-items",
  //           "flex-basis",
  //           "flex-grow",
  //           "flex-shrink",
  //           "align-self",
  //         ],
  //           properties: [
  //             {
  //               property: "position",
  //               type: "radio",
  //               defaults: "static",
  //               list: [
  //                 { value: "static", name: "静态定位" },
  //                 { value: "relative", name: "相对定位" },
  //                 { value: "absolute", name: "绝对定位" },
  //                 { value: "fixed", name: "固定定位" },
  //               ],
  //             },
  //             {
  //               property: "right",
  //               type: "integer",
  //               units: ["px", "%", "vh"],
  //               defaults: "自动",
  //               fixedValues: ["initial", "inherit", "auto"],
  //             },
  //             {
  //               property: "bottom",
  //               type: "integer",
  //               units: ["px", "%", "vh"],
  //               defaults: "自动",
  //               fixedValues: ["initial", "inherit", "auto"],
  //             },
  //             {
  //               property: "display",
  //               type: "select",
  //               defaults: "block",
  //               list: [
  //                 { value: "block", name: "块级元素" },
  //                 { value: "inline", name: "内联元素" },
  //                 { value: "inline-block", name: "行内块级元素" },
  //                 { value: "flex", name: "弹性布局元素" },
  //                 { value: "none", name: "元素隐藏" },
  //               ],
  //             },
  //             {
  //               property: "overflow",
  //               type: "select",
  //               defaults: "visible",
  //               list: [
  //                 { value: "visible", name: "显示" },
  //                 { value: "hidden", name: "隐藏" },
  //                 { value: "scroll", name: "滚动" },
  //                 { value: "auto", name: "自动" },
  //                 { value: "inherit", name: "继承" },
  //               ],
  //             },
  //             {
  //               property: "justify-content",
  //               type: "select",
  //               defaults: "flex-start",
  //               list: [
  //                 { value: "flex-start", name: "从行首开始排列" },
  //                 { value: "flex-end", name: "从行尾开始排列" },
  //                 { value: "center", name: "居中排列" },
  //                 {
  //                   value: "space-between",
  //                   name: "均匀排列（首个元素位于起点，末尾元素位于终点）",
  //                 },
  //                 {
  //                   value: "space-around",
  //                   name: "均匀排列（每个元素周围分配相同的空间）",
  //                 },
  //                 {
  //                   value: "space-evenly",
  //                   name: "均匀排列（每个元素之间的间隔相等）",
  //                 },
  //               ],
  //               requires: { display: ["flex"] },
  //             },
  //             {
  //               property: "flex-direction",
  //               type: "select",
  //               defaults: "row",
  //               list: [
  //                 { value: "row", name: "横向排列" },
  //                 { value: "row-reverse", name: "反转横向排列" },
  //                 { value: "column", name: "纵向排列" },
  //                 { value: "column-reverse", name: "反转纵向排列" },
  //               ],
  //               requires: { display: ["flex"] },
  //             },
  //             {
  //               property: "flex-wrap",
  //               type: "select",
  //               defaults: "nowrap",
  //               list: [
  //                 { value: "nowrap", name: "不换行" },
  //                 { value: "wrap", name: "自动换行" },
  //                 { value: "wrap-reverse", name: "换行（反转排列）" },
  //               ],
  //               requires: { display: ["flex"] },
  //             },
  //             {
  //               property: "align-items",
  //               type: "select",
  //               defaults: "stretch",
  //               list: [
  //                 { value: "flex-start", name: "向侧轴起点对齐" },
  //                 { value: "flex-end", name: "向侧轴终点对齐" },
  //                 { value: "center", name: "在侧轴居中" },
  //                 { value: "baseline", name: "向基线对齐" },
  //                 { value: "stretch", name: "元素拉伸适应容器" },
  //               ],
  //               requires: { display: ["flex"] },
  //             },
  //             {
  //               property: "flex-basis",
  //               type: "integer",
  //               units: ["px", "%", "vw", "vh"],
  //               defaults: "自动",
  //               fixedValues: ["initial", "inherit"],
  //               requiresParent: { display: ["flex"] },
  //               min: 0,
  //             },
  //             {
  //               property: "align-self",
  //               type: "select",
  //               defaults: "auto",
  //               list: [
  //                 { value: "auto", name: "自动" },
  //                 { value: "flex-start", name: "位于容器的顶部" },
  //                 { value: "flex-end", name: "位于容器的尾部" },
  //                 { value: "center", name: "位于容器的中心" },
  //                 { value: "baseline", name: "位于容器基线上" },
  //                 { value: "stretch", name: "元素拉伸适应容器" },
  //               ],
  //               requiresParent: { display: ["flex"] },
  //             },
  //           ],
  //   },
  // {
  //   id: "sector-pos-child-limit",
  //     name: "宽高度限制",
  //       open: false,
  //         buildProps: ["max-width", "min-height"],
  //           properties: [
  //             {
  //               property: "max-width",
  //               type: "integer",
  //               units: ["px", "%", "vh"],
  //               defaults: "自动",
  //               fixedValues: ["initial", "inherit", "auto"],
  //               min: 0,
  //             },
  //             {
  //               property: "min-height",
  //               type: "integer",
  //               units: ["px", "%", "vh"],
  //               defaults: "自动",
  //               fixedValues: ["initial", "inherit", "auto"],
  //               min: 0,
  //             },
  //           ],
  //   },
  // { id: "sector-font", name: "文字", open: false, buildProps: [] },
  // {
  //   id: "sector-font-child-color",
  //     name: "字体颜色",
  //       open: false,
  //         buildProps: ["font-family", "color"],
  //           properties: [
  //             {
  //               property: "font-family",
  //               list: [
  //                 { value: "Arial, Helvetica, sans-serif", name: "Arial" },
  //                 { value: "Arial Black, Gadget, sans-serif", name: "Arial Black" },
  //                 { value: "Brush Script MT, sans-serif", name: "Brush Script MT" },
  //                 { value: "Comic Sans MS, cursive, sans-serif", name: "Comic Sans MS" },
  //                 { value: "Courier New, Courier, sans-serif", name: "Courier New" },
  //                 { value: "Georgia, serif, sans-serif", name: "Georgia" },
  //                 { value: "Helvetica, serif, sans-serif", name: "Helvetica" },
  //                 { value: "Impact, Charcoal, sans-serif", name: "Impact" },
  //                 { value: "Lucida Sans Unicode, Lucida Grande, sans-serif", name: "Lucida Sans Unicode" },
  //                 { value: "Tahoma, Geneva, sans-serif", name: "Tahoma" },
  //                 { value: "Times New Roman, Times, serif, sans-serif", name: "Times New Roman" },
  //                 { value: "Trebuchet MS, Helvetica, sans-serif", name: "Trebuchet MS" },
  //                 { value: "Verdana, Geneva, sans-serif", name: "Verdana" },
  //                 { value: "DS-Digital", name: "DS-Digital" },
  //                 { value: "庞门正道", name: "庞门正道" },
  //               ],
  //             },
  //             {
  //               property: "color",
  //               type: "color",
  //               defaults: "#000",
  //             },
  //           ],
  //   },
  // {
  //   id: "sector-font-child-size",
  //     name: "字号",
  //       open: false,
  //         buildProps: ["font-size", "font-weight"],
  //           properties: [
  //             {
  //               property: "font-size",
  //               type: "integer",
  //               units: ["px", "em", "rem", "%"],
  //               defaults: "12",
  //               min: 0,
  //               fixedValues: [
  //                 "medium",
  //                 "xx-small",
  //                 "x-small",
  //                 "small",
  //                 "large",
  //                 "x-large",
  //                 "xx-large",
  //                 "smaller",
  //                 "larger",
  //                 "length",
  //                 "initial",
  //                 "inherit",
  //               ],
  //             },
  //             {
  //               name: "加粗",
  //               property: "font-weight",
  //               type: "select",
  //               defaults: "400",
  //               list: [
  //                 { value: "100", name: "100px" },
  //                 { value: "200", name: "200px" },
  //                 { value: "300", name: "300px" },
  //                 { value: "400", name: "400px" },
  //                 { value: "500", name: "500px" },
  //                 { value: "600", name: "600px" },
  //                 { value: "700", name: "700px" },
  //                 { value: "800", name: "800px" },
  //                 { value: "900", name: "900px" },
  //               ],
  //             },
  //           ],
  //   },
  // {
  //   id: "sector-font-child-text-align",
  //     name: "对齐方式",
  //       open: false,
  //         buildProps: ["text-align"],
  //           properties: [
  //             {
  //               property: "text-align",
  //               list: [
  //                 { value: "left", className: "fa fa-align-left" },
  //                 { value: "center", className: "fa fa-align-center" },
  //                 { value: "right", className: "fa fa-align-right" },
  //                 { value: "justify", className: "fa fa-align-justify" },
  //               ],
  //             },
  //           ],
  //   },
  // {
  //   id: "sector-font-child-space",
  //     name: "字间距",
  //       open: false,
  //         buildProps: ["letter-spacing"],
  //           properties: [
  //             {
  //               property: "letter-spacing",
  //               type: "integer",
  //               units: ["px", "em", "rem", "%"],
  //               defaults: "默认",
  //               fixedValues: ["normal", "initial", "inherit"],
  //             },
  //           ],
  //   },
  // {
  //   id: "sector-font-child-shadow",
  //     name: "阴影",
  //       open: false,
  //         buildProps: ["text-shadow"],
  //           properties: [
  //             {
  //               property: "text-shadow",
  //               type: "stack",
  //               preview: true,
  //               defaults: "none",
  //               properties: [
  //                 {
  //                   property: "text-shadow-h",
  //                   type: "integer",
  //                   units: ["px", "%"],
  //                   defaults: 0,
  //                 },
  //                 {
  //                   property: "text-shadow-v",
  //                   type: "integer",
  //                   units: ["px", "%"],
  //                   defaults: 0,
  //                 },
  //                 {
  //                   property: "text-shadow-blur",
  //                   type: "integer",
  //                   units: ["px", "%"],
  //                   defaults: 0,
  //                   min: 0,
  //                 },
  //                 {
  //                   property: "text-shadow-color",
  //                   type: "color",
  //                   defaults: "#000",
  //                 },
  //               ],
  //             },
  //           ],
  //   },
  // {
  //   id: "sector-font-child-line-height",
  //     name: "行高",
  //       open: false,
  //         buildProps: ["line-height"],
  //           properties: [
  //             {
  //               property: "line-height",
  //               type: "integer",
  //               units: ["px", "em", "rem", "%"],
  //               defaults: "默认",
  //               fixedValues: ["normal", "initial", "inherit"],
  //             },
  //           ],
  //   },
  // { id: "sector-style", name: "样式", open: false },
  // {
  //   id: "sector-style-child-background",
  //     name: "背景填充",
  //       open: false,
  //         buildProps: ["background", "background-color"],
  //           properties: [
  //             {
  //               property: "background",
  //               type: "stack",
  //               preview: true,
  //               detached: true,
  //               properties: [
  //                 {
  //                   name: "背景图片",
  //                   property: "background-image",
  //                   type: "file",
  //                   functionName: "url",
  //                 },
  //                 {
  //                   name: "背景图重复方式",
  //                   property: "background-repeat",
  //                   type: "select",
  //                   defaults: "repeat",
  //                   list: [
  //                     { value: "repeat", name: "双向重复" },
  //                     { value: "repeat-x", name: "横向重复" },
  //                     { value: "repeat-y", name: "纵向重复" },
  //                     { value: "no-repeat", name: "不重复" },
  //                   ],
  //                 },
  //                 {
  //                   name: "背景图起始位置",
  //                   property: "background-position",
  //                   type: "select",
  //                   defaults: "left top",
  //                   list: [
  //                     { value: "left top", name: "左侧顶部" },
  //                     { value: "left center", name: "左侧中部" },
  //                     { value: "left bottom", name: "左侧底部" },
  //                     { value: "right top", name: "右侧顶部" },
  //                     { value: "right center", name: "右侧中部" },
  //                     { value: "right bottom", name: "右侧底部" },
  //                     { value: "center top", name: "中间顶部" },
  //                     { value: "center center", name: "中间中部" },
  //                     { value: "center bottom", name: "中间底部" },
  //                   ],
  //                 },
  //                 {
  //                   name: "背景图滚动方式",
  //                   property: "background-attachment",
  //                   type: "select",
  //                   defaults: "scroll",
  //                   list: [
  //                     { value: "scroll", name: "相对元素固定" },
  //                     { value: "fixed", name: "相对页面固定" },
  //                     { value: "local", name: "相对元素内容固定" },
  //                   ],
  //                 },
  //                 {
  //                   name: "背景图尺寸",
  //                   property: "background-size",
  //                   type: "select",
  //                   defaults: "auto",
  //                   list: [
  //                     { value: "auto", name: "自动" },
  //                     { value: "cover", name: "覆盖画布" },
  //                     { value: "contain", name: "包含于画布" },
  //                   ],
  //                 },
  //               ],
  //             },
  //             {
  //               property: "background-color",
  //               type: "color",
  //               defaults: "rgba(0,0,0,0)",
  //             },
  //           ],
  //   },
  // {
  //   id: "sector-style-child-border",
  //     name: "边框线",
  //       open: false,
  //         buildProps: ["border"],
  //           properties: [
  //             {
  //               property: "border",
  //               type: "composite",
  //               properties: [
  //                 {
  //                   property: "border-width",
  //                   type: "integer",
  //                   units: ["px", "em"],
  //                   defaults: 0,
  //                   min: 0,
  //                 },
  //                 {
  //                   property: "border-style",
  //                   type: "select",
  //                   defaults: "solid",
  //                   list: [
  //                     { value: "none", name: "无边框" },
  //                     { value: "solid", name: "实线边框" },
  //                     { value: "dotted", name: "点线边框" },
  //                     { value: "dashed", name: "虚线边框" },
  //                     { value: "double", name: "双线边框" },
  //                     { value: "groove", name: "3D凹槽边框" },
  //                     { value: "ridge", name: "3D凸起边框" },
  //                     { value: "inset", name: "3D凹边" },
  //                     { value: "outset", name: "3D凸边" },
  //                   ],
  //                 },
  //                 {
  //                   property: "border-color",
  //                   type: "color",
  //                   defaults: "#000",
  //                 },
  //               ],
  //             },
  //           ],
  //   },
  // {
  //   id: "sector-style-child-border-radius",
  //     name: "边框圆角",
  //       open: false,
  //         buildProps: ["border-radius-c", "border-radius"],
  //   },
  // {
  //   id: "sector-style-child-shadow",
  //     name: "投影",
  //       open: false,
  //         buildProps: ["box-shadow"],
  //           properties: [
  //             {
  //               property: "box-shadow",
  //               type: "stack",
  //               preview: true,
  //               properties: [
  //                 {
  //                   property: "box-shadow-h",
  //                   type: "integer",
  //                   units: ["px", "%"],
  //                   defaults: 0,
  //                 },
  //                 {
  //                   property: "box-shadow-v",
  //                   type: "integer",
  //                   units: ["px", "%"],
  //                   defaults: 0,
  //                 },
  //                 {
  //                   property: "box-shadow-blur",
  //                   type: "integer",
  //                   units: ["px"],
  //                   defaults: "5px",
  //                   min: 0,
  //                 },
  //                 {
  //                   property: "box-shadow-spread",
  //                   type: "integer",
  //                   units: ["px"],
  //                   defaults: 0,
  //                 },
  //                 {
  //                   property: "box-shadow-color",
  //                   type: "color",
  //                   defaults: "#000",
  //                 },
  //                 {
  //                   property: "box-shadow-type",
  //                   type: "select",
  //                   defaults: "",
  //                   list: [
  //                     { value: "", name: "外侧阴影" },
  //                     { value: "inset", name: "内侧阴影" },
  //                   ],
  //                 },
  //               ],
  //             },
  //           ],
  //   },
};

export const i18n = {
  zh_CN: {
    assetManager: {
      addButton: "添加图片",
      modalTitle: "选择图片",
      uploadTitle: "点击或者拖拽图片上传",
    },

    domComponents: {
      names: {
        "": "盒子",
        text: "显示文本",
        label: "文本标签",
        table: "表格",
        tbody: "表格主体",
        thead: "表头",
        tfoot: "表格页脚",
        cell: "单元格",
        row: "行",
        button: "按钮",
        input: "输入框",
        link: "链接",
        "form-input": "表单输入框",
        "msc-checkbox": "多选选项",
        "msc-radio": "单选选项",
        "mdc-radio": "单选选项",
        "mdc-checkbox": "多选选项",
        hr: "水平线",
        textarea: "多行文本",
        form: "表单",
        span: "行内文本标签",
        pre: "预格式化文本",
        "Tabs": "标签页",
        "Tab Container": "标签头",
        "Tab Content": "标签内容",
        "button-group": "按钮组",
        "Text": "显示文本",
        "Default": "显示文本",
        "xly-text": "显示文本",
        "group-text": "组合文本",
        "xly-led": "灯",
        "xly-btnGroup": "按钮组",
        "xly-range": "范围选框",
        "xly-imgBase64": "图片",
        "xly-box": "盒子",
        "xly-header": "标题",
        "xly-iframe": "页面嵌套",
        "head-line": "标题",
        "head-line2": "标题",
        "tag-item": "标签",
        "card-status": "卡片状态",
        "progress-comp": "进度条",
        "button-comp": "按钮",
        "current-time": "当前时间",
        "modal-comp": "模态窗",
        "layoutTable": "布局表格",
        "custom-time": "自定义时间",
        "weather": "天气",
        "xly-customCarousel": "轮播",
        "linear-regression-scatter-Chart": "线性回归散点图",
        "bar-group-Chart": "柱形图",
        "pictorialBar-line-Chart": "象形柱线图",
        "pictorialBar-line-category-Chart": "分组象形柱线图",
        "circular-progress": "环形进度条",
        "xly-hoop": "比例环",
        "path-image": "路径图片",
        "custom-video": "视频",
        "relative-link": "相对链接",
        "sp-code": "代码",
        "pie-Chart": "饼状图",
        "bar-Chart": "柱形图",
        "funnel-Chart": "漏斗图",
        "line-Chart": "线形图",
        "line-MarkPoint-chart": "线形标注图",
        "close-line-Chart": "包线图",
        "bar-line-Chart": "柱线图",
        "pictorialBar-Chart": "象形柱形图",
        "rectStackBar-Chart": "方块堆叠柱图",
        "ring-Chart": "环形图",
        "gauge-chart": "仪表盘",
        "scatter-Chart": "连续型散点图",
        "piece-scatter-Chart": "离散型散点图",
        "polar-bar-Chart": "极坐标柱形图",
        "single-ring": "占比单环",
        "heatmap": "热力图",
        "heatmap-calendar-Chart": "热力图日历坐标系",
        "map3D-Chart": "3D地图",
        "map3DPopup-Chart": "3D弹窗地图",
        "map2DPopup-Chart": "2D弹窗地图",
        "mapScatter-Chart": "散点地图",
        "mapHeatmap": "热力图地图坐标系",
        "radar-Chart": "雷达图",
        "oscilloscope": "示波器",
        "form-panel": "面板",
        "form-select": "下拉列表",
        "select-comp": "下拉列表",
        "dynamic-text": "动态文本",
        "scenario-dynamic-text": "动态文本",
        "group-led": "组合灯",
        "dynamic-led": "动态灯",
        "switch-comp": "开关",
        "form-switch": "开关",
        "check-file": "选择文件夹",
        "date-range-picker": "日期选择框",
        "date-range-picker-input": "日期选择框",
        "rating": "排行",
        "horizontal-rule": "水平线",
        "multiline": "多行文本",
        "cascade-address": "层级地址选择器",
        "geolocation": "开启定位",
        "checkbox-group": "组合复选框",
        "phone": "电话号码",
        "rich-text": "富文本",
        "json-viewer": "JSON预览",
        "nav-tags": "标签组",
        "jq-slider": "滑块",
        "mdc-radio-group": "单选组",
        "mdc-checkbox-group": "多选组",
        "mdc-textfield": "输入框",
        "mdc-select": "下拉列表",
        "mdc-slider": "滑块",
        "mdc-table": "表格",
        "table-simple": "表格",
        "list-comp": "列表",
        "card-setting": "设置卡",
        "app-popover": "气泡",
        "xly-card-list": "卡片列表",
        "xly-gante-chart": "甘特图",
        "xly-svg": "SVG图片",
        "xly-streamComputing": "流计算",
        "xly-detection-result": "检测结果",
        "BidirectionalBar-Chart": "双向柱形图",
        "doubleRing-Chart": "双环图",
        "animate-pie": "动态饼图",
        "ranking-list": "排行榜",
        "sp-control-input": "输入框",
        "sp-upload": "文件上传",
        "radio": "单选",
        "input-comp": "输入框",
      },
    },

    styleManager: {
      properties: {
        width: "宽度",
        height: "高度",
        left: "X",
        top: "Y",
        background: "背景",
        "background-color": "背景颜色",
        "background-image": "背景图片",
        "background-repeat": "背景图重复方式",
        border: "边框",
        "border-width": "宽度",
        "border-style": "类型",
        "border-color": "颜色",
        "font-size": "字号",
        "font-weight": "加粗",
        color: "字体颜色",
        "text-align": "对齐方式",
        position: "位置",
        right: "右侧",
        bottom: "下方",
        margin: "外边距",
        "margin-top": "上",
        "margin-bottom": "下",
        "margin-left": "左",
        "margin-right": "右",
        padding: "内边距",
        "padding-top": "上",
        "padding-bottom": "下",
        "padding-left": "左",
        "padding-right": "右",
        "font-family": "字体",
        "letter-spacing": "字间距",
        "line-height": "行高",
        "text-shadow": "文字阴影",
        "border-radius": "圆角",
        "border-top-left-radius": "左上",
        "border-bottom-left-radius": "左下",
        "border-top-right-radius": "右上",
        "border-bottom-right-radius": "右下",
        "box-shadow": "投影",
        "max-width": "最大宽度",
        "min-height": "最小高度",
        float: "浮动",
        "z-index": "元素堆叠优先级",
        display: "元素显示类型",
        overflow: "溢出",
        "text-shadow-h": "水平方向偏移",
        "text-shadow-v": "垂直方向偏移",
        "text-shadow-blur": "模糊范围",
        "text-shadow-color": "阴影颜色",
        "box-shadow-h": "水平方向偏移",
        "box-shadow-v": "垂直方向偏移",
        "box-shadow-blur": "模糊范围",
        "box-shadow-spread": "阴影大小",
        "box-shadow-color": "阴影颜色",
        "box-shadow-type": "阴影类型",
        "flex-direction": "元素排列方向",
        "flex-wrap": "元素是否换行",
        "justify-content": "元素对齐方式（横轴方向）",
        "align-items": "容器对齐方式",
        "flex-basis": "弹性盒伸缩基准值",
        "flex-grow": "弹性盒扩展比率",
        "flex-shrink": "弹性盒收缩比率",
        "align-self": "元素对齐方式（纵轴方向）",
      },
      layer: "图层",
      empty: "设置样式前选择请一个元素",
      fileButton: "添加图片",
    },
  }
}

export const defaultOptions = {
  background: "green",
  height: "100%",
  allowScripts: 1,
  avoidInlineStyle: 1,
  fromElement: true,
  colorPicker: {
    appendTo: 'body'
  },
  canvasCss:
    ` .gjs-selected {
        outline: 1px dashed #3b97e3 !important;
        outline-offset: 0;
      }
      .gjs-css-rules {
        display: none;
      }
      .gjs-js-cont {
        display: none;
      }
    `,
  clearStyles: 1,
  storageManager: {
    stepsBeforeSave: 6,
  },

  plugins: [],

  i18n: {
    locale: "zh_CN",
    detectLocale: false,
    messages: { zh_CN: i18n.zh_CN },
  },

  styleManager: {
    stylePrefix: 'sp-stylemanager-',
    clearProperties: 1,
    // sectors: defaultSectors
  },
  pluginsOpts: {},
  panels: {
    defaults: [
      {
        id: "layers",
        el: "#layers-container",
        resizable: {
          tc: 0,
          cr: 1,
          bc: 0,
          keyWidth: "flex-basis",
        },
      },
      {
        id: "styles",
        el: "#style-container",
        resizable: {
          tc: 0,
          cr: 0,
          cl: 1,
          bc: 0,
          keyWidth: "flex-basis",
        },
      },
    ],
  }
};
